<template>
    <div class="roomPrice">
        
      <iframe scrolling: no
        :src="src"
        frameborder="0"
      ></iframe>
    </div>
  </template>
  
  <script>
  import urls from "../../../utils/baseUrl2.js";
  export default {
    name: "seckillPrice",
    props: {
      id: {
        type: [Number, String],
        required: true,
      },
      packId:{
        type: [Number, String],
        required: true,
      }
    },
    data() {
      return {
        src: `${urls.baseUrl}giftPackagePrice/roomPriceIframe.html?roomId=${this.id}&isDevelopment=${urls.baseUrl}&hotelId=${this.packId}`,
      };
    },
    mounted() {
        console.log(this.packId,'----------this.packId')
    },
    created() {},
    methods: {},
  };
  </script>
  <style scoped lang='less'>
  .roomPrice {
    height: 860px;
    iframe {
      width: 100%;
      height: 100%;
    }
  }
  </style>